export default function OrderFooter({ total, leftButton, rightButton, style = {} }) {
  const defaultStyle = {
    height: '80px',
    background: '#1a1a2e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
    zIndex: 100,
  }

  return (
    <div style={{ ...defaultStyle, ...style }}>
      <span style={{ color: '#fff', fontSize: '28px', fontWeight: 'bold' }}>
        {total.toFixed(2)}€
      </span>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          style={{
            padding: '12px',
            background: leftButton.color || '#f44336',
            border: 'none',
            borderRadius: '8px',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '14px'
          }}
          onClick={leftButton.onClick}
        >
          {leftButton.label}
        </button>
        <button
          style={{
            padding: '12px',
            background: rightButton.color || '#4ecdc4',
            border: 'none',
            borderRadius: '8px',
            color: '#fff',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '14px'
          }}
          onClick={rightButton.onClick}
        >
          {rightButton.label}
        </button>
      </div>
    </div>
  )
}